import { scrollToSection } from '../../../../common/utilities';
export const handleClick = (
  ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
) => {
  if (setActive) {
    setActive(ev);
  }
  scrollToSection(ev);
};
